// extracted by mini-css-extract-plugin
export default {"label":"BlockToolLabel_label__IVTfv"};